import { atom } from "recoil";

export const withInstalled = atom({
    key: 'withInstalled',
    default: false
})